<div *ngIf="displayHistory">
	<mat-card *ngFor="let kvp of displayHistory | keyvalue: reverseKeyOrder; let i = index">
		<mat-card-title [id]="idPrefix + '_CHANGE_' + i + '_TITLE'">
			Starting {{ kvp.key | date: 'MMMM-yyyy' }}</mat-card-title
		>
		<mat-card-content>
			<mat-list dense>
				<ng-container *ngFor="let item of kvp.value; let j = index">
					<mat-list-item *ngIf="item.field !== newRecordText && item.field !== 'PayCategoryNoteArchived'">
						<span>
							<span [id]="idPrefix + '_CHANGE_' + i + '_ITEM_' + j" class="field-name"
								>{{ item.field }} {{ item.extraFieldDescription }}
							</span>
							<span *ngIf="item.isFuture && item.oldValue && item.newValue"> changes </span>
							<span *ngIf="(!item.isFuture && item.oldValue) || (!item.oldValue && !item.effectiveDate)">
								changed
							</span>

							<span *ngIf="item.oldValue; then oldValueDisplay"></span>
							<span *ngIf="item.newValue; then newValueDisplay"></span>
							<span *ngIf="item.changedByUserDisplayName; then showChangedByUser"></span>

							<ng-template #oldValueDisplay>
								<span *ngIf="!item.isColor && !item.isIcon && item.newValue">
									from <span class="field-value">{{ item.oldValue }} </span></span
								>
								<span *ngIf="item.isColor">
									from
									<span class="color-pallet" [style.background]="item.oldValue"
										>&nbsp;&nbsp;&nbsp;</span
									>
								</span>
								<span *ngIf="item.isIcon">
									from
									<i class="fa-1-5x fa {{ item.oldValue }}"></i>
								</span>
							</ng-template>

							<ng-template #newValueDisplay>
								<span *ngIf="!item.isColor && !item.isIcon">
									<span *ngIf="item.field !== 'New Note Created'"> to </span>
									<span class="field-value"> {{ item.newValue }}</span></span
								>
								<span *ngIf="item.isColor">
									to
									<span class="color-pallet" [style.background]="item.newValue"
										>&nbsp;&nbsp;&nbsp;</span
									>
								</span>
								<span *ngIf="item.isIcon">
									to
									<i class="fa-1-5x fa {{ item.newValue }}"></i>
								</span>
							</ng-template>

							<ng-template #showChangedByUser>
								<span class="changed-by">
									(changed by {{ item.changedByUserDisplayName }} on
									{{ item.changeDate | date: 'dd-MMMM-yyyy' }} )</span
								>
							</ng-template>
						</span>
					</mat-list-item>

					<mat-list-item *ngIf="item.field === newRecordText" [id]="idPrefix + '_CHANGE_' + i + '_ITEM_' + j">
						<span>
							{{ item.field }}
						</span>
					</mat-list-item>
				</ng-container>
			</mat-list>
		</mat-card-content>
	</mat-card>
</div>
